module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABSklEQVQ4T6WUTSuFURSFn+U7H8XMwIiRISkJAyVSkpHiVzAgGTFSRmYGBn4BQ/ITDEyQCekOJKlb5CNJlrburTe87nvdXWd21nP22WudI9sHwCDwSLZqAi6AAUnvRYlsB6BD0kMWju0G4BLolXSXBN1Kas8CKe6xfQKMZgLZrgqhpI/vh5QLmgaqJe1WBPrrquV2NALUSTqsqCPbc0C9pJ1fQMfAmKR8SddKgFol3ScPiBz9sN/2BLABhHOLkvZDZLsNiFWsV0k3X+6mgBqBo8LufkkvBdA6MAT0AKfAEzAeEfkVVBB1FnJ0lTLs4eRrSAVlsP9/INvdQDjYDHQBOeANWJO0l7kj20tADbCV6DZmNS9pKkAxyFngOuU6eUk528tAuLSZeLx9wKqkyQAtAJHitDqTtFISlOX7sL0NzESUgOeEphZoAc4/AVoaz92Tq/3TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/fenyong_tab.png
// module id = ZV+I
// module chunks = 1